import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../../services/api';
import { hojeBR } from '../../utils/data';
import s from '../../pages/PedidosOrcamentos.module.css';
import InputDataFiltro from '../common/InputDataFiltro';
import useNavegacaoLista from '../../hooks/useNavegacaoLista';

const fmtMoeda = v => Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
const fmtData  = str => { if (!str) return '—'; return new Date(String(str).slice(0,10)+'T12:00:00').toLocaleDateString('pt-BR'); };
const hoje     = () => hojeBR();

const STATUS_LABEL = {
  aberto:    { txt: 'Aberto',    cls: s.badgeAberto    },
  vencido:   { txt: 'Vencido',   cls: s.badgeCancelado },
  pago:      { txt: 'Pago',      cls: s.badgeAprovado  },
  cancelado: { txt: 'Cancelado', cls: s.badgeCancelado },
};

const statusEfetivo = (cp) => {
  if (cp.status === 'pago' || cp.status === 'cancelado') return cp.status;
  if (cp.data_vencimento && cp.data_vencimento < hoje()) return 'vencido';
  return 'aberto';
};

/* ── Modal Busca ── */
export default function ModalBuscaContaPagar({ onSelect, onClose }) {
  const [filtros, setFiltros] = useState({ busca:'', status:'aberto', venc_de:'2000-01-01', venc_ate:'2099-12-31' });
  const [lista, setLista]     = useState([]);
  const [sel, setSel]         = useState(null);
  const inputRef = useRef(null);

  const buscar = useCallback(async (f) => {
    try {
      const { data } = await api.get('/financeiro/contas-pagar', { params: f });
      setLista(data);
    } catch { setLista([]); }
  }, []);

  useEffect(() => { buscar(filtros); setTimeout(() => inputRef.current?.focus(), 60); }, []); // eslint-disable-line

  const set = (k,v) => {
    const nf = {...filtros,[k]:v};
    setFiltros(nf);
    buscar(nf);
  };

  const refLinha = useNavegacaoLista({
    lista, indice: lista.findIndex(c => c.id === sel), aoMudar: c => setSel(c.id), aoEnter: onSelect,
  });

  return (
    <div className={s.overlay} data-enter-scope="off" onMouseDown={e => e.target===e.currentTarget && onClose()}>
      <div className={s.modal} style={{width:780}}>
        <div className={s.modalTitle}>Buscar Conta a Pagar</div>
        <div className={s.modalBody}>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:8}}>
            <input ref={inputRef} className={s.inputErp} style={{flex:1,minWidth:200}}
              placeholder="Descrição ou fornecedor..." value={filtros.busca}
              onChange={e=>set('busca',e.target.value)} />
            <select className={s.selectErp} value={filtros.status} onChange={e=>set('status',e.target.value)}>
              <option value="todos">Todos</option>
              <option value="aberto">Aberto</option>
              <option value="vencido">Vencido</option>
              <option value="pago">Pago</option>
              <option value="cancelado">Cancelado</option>
            </select>
            <label style={{fontSize:11,alignSelf:'center'}}>Venc. de</label>
            <InputDataFiltro className={s.inputErp} style={{width:130}} value={filtros.venc_de} onChange={e=>set('venc_de',e.target.value)} />
            <label style={{fontSize:11,alignSelf:'center'}}>até</label>
            <InputDataFiltro className={s.inputErp} style={{width:130}} value={filtros.venc_ate} onChange={e=>set('venc_ate',e.target.value)} />
          </div>
          <div style={{maxHeight:360,overflowY:'auto'}}>
            <table className={s.modalTabela}>
              <thead><tr>
                <th style={{width:60}}>Cód.</th>
                <th>Descrição</th>
                <th>Fornecedor</th>
                <th style={{width:90}}>Vencimento</th>
                <th style={{width:100,textAlign:'right'}}>Valor</th>
                <th style={{width:80}}>Status</th>
              </tr></thead>
              <tbody>
                {lista.length===0&&<tr><td colSpan={6} style={{textAlign:'center',color:'#888',padding:12}}>Nenhum resultado.</td></tr>}
                {lista.map(c=>{
                  const st = STATUS_LABEL[statusEfetivo(c)] || STATUS_LABEL.aberto;
                  return (
                    <tr key={c.id} ref={sel===c.id?refLinha:null} className={sel===c.id?s.linhaAtiva:''} style={{cursor:'pointer'}}
                      onClick={()=>setSel(c.id)} onDoubleClick={()=>onSelect(c)}>
                      <td>{c.id}</td>
                      <td>{c.descricao}</td>
                      <td>{c.fornecedor_nome||'—'}</td>
                      <td>{fmtData(c.data_vencimento)}</td>
                      <td style={{textAlign:'right'}}>{fmtMoeda(c.valor)}</td>
                      <td><span className={`${s.badge} ${st.cls}`}>{st.txt}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className={s.modalFooter}>
          <button className={`${s.btnErp} ${s.btnErpPrimario}`} disabled={!sel}
            onClick={()=>{ const c=lista.find(x=>x.id===sel); if(c) onSelect(c); }}>Ok</button>
          <button className={s.btnErp} onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

/* ── Modal Baixa ── */
